<template>
  <div
    v-if="unreadNotificationCount"
    class="counter"
  >
    <span class="counter__count">
      {{ unreadNotificationCount }}
    </span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('notification', ['unreadNotificationCount'])
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .counter {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -25%);
    width: 55%;
    height: 55%;
    border-radius: 100%;
    // background: #f7412d;
    // background: #ff8000;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid $highlightPrimaryColor;;
    

    &__count {
      color: $highlightPrimaryColor;
      font-size: 13px;
      color: $highlightPrimaryColor;
    }
  }
</style>